import * as React from "react"
import { DeleteWithConfirmButton, useRecordContext } from "react-admin"

import { Customer } from "../types"

const MycustomeDeleteButton = () => {
  const record = useRecordContext<Customer>()
  if (!record) {
    return null
  }
  return (
    <DeleteWithConfirmButton
      label="Delete"
      confirmTitle={`Delete  ${record.first_name || record.firstName}`}
    />
  )
}

export default MycustomeDeleteButton
